import DetectIE from './DetectIE';
export default DetectIE;